// extracted by mini-css-extract-plugin
module.exports = {"main":"StatusConfirmed_main__PaCrt","textInfo":"StatusConfirmed_textInfo__WnyHT"};